<template>
  <b-row>
    <b-modal v-model="showModal" :title="`${selectedIndex !== null ? 'Edit' : 'Add'} Sub Contractor`" size="lg"
      @hide="onHide">
      <FormSubcon :forms="forms" :selectedIndex="selectedIndex" />
      <template #modal-footer="{ cancel }">
        <div>
          <b-button variant="outline-primary" class="mr-2" @click="cancel()">Cancel & Close</b-button>
          <b-button v-if="selectedIndex == null" variant="outline-primary" class="mr-2" @click="addForm">Add
            Form</b-button>
          <b-button variant="primary" class="" @click="addToList">Save & Close</b-button>
        </div>
      </template>
    </b-modal>
    <b-col v-if="createAble" lg="12" class="mb-3 d-flex justify-content-end">
      <b-button variant="outline-primary" size="sm" @click="showModal = true, selectedIndex = null">Add Data Sub
        Contractor</b-button>
    </b-col>
    <b-col lg="12">
      <div class="overflow-auto">
        <table class="w-100">
          <thead>
            <th class="text-nowrap" style="min-width:340px">Contractor Name</th>
            <th class="text-nowrap" style="min-width: 140px;">PIC</th>
            <th class="text-nowrap" style="min-width: 140px;">Email PIC</th>
            <th class="text-nowrap" style="min-width: 140px;">Phone PIC</th>
            <th class="text-nowrap" style="min-width: 140px;">Est. Cost</th>
            <th>Attachment</th>
            <th>Remarks</th>
            <th v-if="createAble" class="text-nowrap text-center">Action</th>
          </thead>
          <tbody>
            <tr class="bg-white" v-for="(item, index) in data" :key="index">
              <td style="min-width:340px">{{ item?.subkon_name }}</td>
              <td>{{ item.subkon_pic }}</td>
              <td>{{ item.subkon_pic_email }}</td>
              <td>{{ item.subkon_pic_phone }}</td>
              <td>{{ formatCurrency(item.subkon_price_deal) }}</td>
              <td class="td-attach">
                <div class="attac-style-wrap">
                  <div class="attac-style" v-for="(url, i) in item.filePreview" :key="`${index}-${i}`">
                    <AttachmentSR :isPreview="true" :modelId="item.id" modelName="sr_form_repair_entity"
                      @delete="handleDeleteFile(item, i)" :file="url" />
                  </div>
                </div>
              </td>
              <td class="td-remark">{{ item.subkon_notes }}</td>
              <td class="p-2 d-flex" v-if="createAble">
                <b-button class="mr-2" @click="$emit('onDelete', index)" variant="outline-primary" size="sm">
                  <i class="fa fa-trash m-0"></i>
                </b-button>
                <b-button @click="() => handleEdit(item, index)" variant="outline-success" size="sm">
                  <i class="fa fa-edit m-0"></i>
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-col>
    <div v-if="!data?.length" class="p-3 d-flex justify-content-center w-100">
      <img :src="require('@/public/img/not-found-image.png')" alt="not-found-image" width="160" height="140" />
    </div>
  </b-row>
</template>
<script>
import AttachmentSR from './AttachmentSR.vue'
import FormSubcon from './FormSubcon.vue'

export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    createAble: Boolean,
    item_id: null,
  },
  data() {
    return {
      showModal: false,
      selectedIndex: null,
      selectedItem: null,
      listSubcon: [],
      initialForm: {
        repair_form_id: this.item_id,
        entity_type: 'sub_kontraktor',
        user_id: JSON.parse(localStorage.getItem('profile')).id,
        internal_name: '',
        internal_position_id: '',
        subkon_name: '',
        subkon_pic: '',
        subkon_pic_phone: '',
        subkon_pic_email: '',
        subkon_price_offering: '',
        subkon_price_nego: '',
        subkon_price_deal: '',
        subkon_notes: '',
        subkon_file: [],
      },
      forms: [
        {
          repair_form_id: this.item_id,
          entity_type: 'sub_kontraktor',
          user_id: JSON.parse(localStorage.getItem('profile')).id,
          internal_name: '',
          internal_position_id: '',
          subkon_name: '',
          subkon_pic: '',
          subkon_pic_phone: '',
          subkon_pic_email: '',
          subkon_price_offering: '',
          subkon_price_nego: '',
          subkon_price_deal: '',
          subkon_notes: '',
          subkon_file: [],
        }
      ],
    }
  },
  components: {
    FormSubcon,
    AttachmentSR,
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(value)
    },
    addForm() {
      this.forms.push({ ...this.initialForm, filePreview: [] })
    },
    addToList() {
      // this.listSubcon = this.forms
      if (this.selectedIndex == null) {
        this.$emit('addData', this.forms)
      } else {
        this.$emit('editData', this.selectedIndex, this.forms[0])
      }
      this.showModal = false
    },
    onHide() {
      this.forms = [{ ...this.initialForm, filePreview: [] }]
    },
    handleDeleteFile(item, idx) {
      const newFiles = item.filePreview.filter((_, i) => i !== idx)
      const newFileUploads = item.subkon_file.filter((_, i) => i !== idx)
      item.filePreview = newFiles
      item.subkon_file = newFileUploads
    },
    handleEdit(item, index) {
      this.selectedIndex = index
      this.forms = [{ ...item }]
      this.showModal = true
    },
    parseJson(arrString) {
      return JSON.parse(arrString)
    }
  },
}
</script>

<style scoped>
.overflow-auto {
  overflow: auto;
}

table th {
  padding: 8px;
}

table td {
  padding: 8px;
  border-bottom: 1px solid gray;
  /* min-width: 200px; */
}

.td-attach {
  width: 256px;
}

.td-remark {
  min-width: 320px;
}

.attac-style-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 256px;
  gap: 8px;
}

.attac-style {
  width: 120px;
}

.max-w-15 {
  max-width: 100px !important;
}
</style>
